// @flow
import {
  type JSSThemeShapeType,
  type JSSThemeVariablesShapeType,
  getColorCombinations,
  type ColorTypes,
  type GetJSSThemePatternsType,
  colorTypes,
} from '../JSSThemeDefault';
import { applyOnlyDesktop } from '../jss-helpers';
import { JSSThemeBetslip as betslip } from './JSSThemeBetslip61900';
import { JSSThemeMyBets61900 } from './JSSThemeMyBets61900';
import { JSSThemeSportsMenu61900 } from './JSSThemeSportsMenu61900';
import { JSSThemeForm61900 } from './JSSThemeForm61900';
import { JSSThemeBannerItems61900 } from './JSSThemeBannerItems61900';
import { JSSThemeHeaderMobile61900 } from './JSSThemeHeaderMobile61900';
import { JSSThemeOutcomes61900 } from './JSSThemeOutcomes61900';
import { JSSThemeHeaderMenu61900 } from './JSSThemeHeaderMenu61900';
import { JSSThemeHeader61900 } from './JSSThemeHeader61900';
import { JSSThemeBalance61900 } from './JSSThemeBalance61900';
import { JSSThemeBonuses61900 } from './JSSThemeBonuses61900';
import { JSSThemeCoupons61900 } from './JSSThemeCoupons61900';
import { JSSThemeAuthForm61900 } from './JSSThemeAuthForm61900';
import { JSSThemePopularLeagues61900 } from './JSSThemePopularLeagues61900';
import { JSSTheme61900Resets } from './JSSTheme61900Resets';
import { JSSThemeCasino61900 } from './JSSThemeCasino61900';
import { JSSThemeTooltip61900 } from './JSSThemeTooltip61900';
import { JSSThemeSearch61900 } from './JSSThemeSearch61900';
import { JSSThemeAccountSection61900 } from './JSSThemeAccountSection61900';
import { JSSThemeFooterAll61900 } from './JSSThemeFooterAll61900';
import { JSSThemeLive61900 } from './JSSThemeLive61900';
import { JSSThemeOryx61900 } from './JSSThemeOryx61900';
import { JSSThemeDropdownMenu61900 } from './JSSThemeDropdownMenu61900';
import { JSSThemeAffiliates61900 } from './JSSThemeAffiliates61900';
import { JSSThemePromotions61900 } from './JSSThemePromotions61900';
import { JSSThemeRegistration61900 } from './JSSThemeRegistration61900';

export const colorTypes61900: ColorTypes = {
  ...colorTypes,
  primary: '#29b93a',
  text1: '#fff',
  text2: '#fff',
  text3: '#333333',
  text4: '#333333',
  text5: '#eaeaea',
  background1: '#709C76',
  background2: '#a2a2a2',
  background3: '#82C191',
  background4: '#0C101B',
  background5: '#222639',
  background6: '#484848', // new color
  background7: '#E0F2ED',
  shadow: 'rgba(0, 0, 0, 0.4)',
  accent: '#709C76',
  success: '#54f763',
  error: '#ff3939',
  error2: '#d12626',
  error3: '#d12626',
  warning: 'orange',
  inform: '#68c124',
  neutral1: '#333333',
  neutral2: '#333333',
  neutral3: '#709C76',
  neutral4: '#e6e0e0',
  border1: '#fff',
  border2: '#fefefe',
};

const pick = ({
  text3Border2,
  whitePrimary,
  text2Primary,
  whiteBg2,
  whiteBg4,
  whiteBg1,
  whiteText3,
  whiteNeutral2,
  whiteNeutral1,
  text2Neutral2,
  whiteSuccess,
  whiteAccent,
  whiteInform,
  whiteBorder1,
  whiteBorder2,
  bg4Border2,
  text3Bg4,
  text4Bg4,
  text2White,
  whiteNeutral3,
  text4Bg2,
  text2Text3,
  text3White,
  whiteBg3,
}) => ({
  text3Border2,
  whitePrimary,
  text2Primary,
  whiteBg2,
  whiteBg4,
  whiteBg1,
  whiteText3,
  whiteNeutral1,
  whiteNeutral2,
  text2Neutral2,
  whiteSuccess,
  whiteAccent,
  whiteInform,
  whiteBorder1,
  whiteBorder2,
  bg4Border2,
  text3Bg4,
  text4Bg4,
  text2White,
  whiteNeutral3,
  text4Bg2,
  text2Text3,
  text3White,
  whiteBg3,
});

export const colorCombinations61900 = getColorCombinations(
  colorTypes61900,
  pick
);

export const JSSThemeVariables61900: JSSThemeVariablesShapeType = {
  fonts: {
    default: {
      name: 'osg-open',
      fontFamily: 'osg-open, Helvetica Neue, Helvetica, Arial, sans-serif',
      config: [
        {
          path: 'Open/opensans-regular-webfont',
          fontWeight: 'normal',
          fontStyle: 'normal',
        },
        {
          path: 'Open/opensans-bold-webfont',
          fontWeight: 'bold',
          fontStyle: 'normal',
        },
      ],
    },
  },
  colors: {
    colorTypes: colorTypes61900,
    colorCombinations: colorCombinations61900,
  },
};

export const JSSTheme61900: JSSThemeShapeType = (themeVars) => {
  const {
    colors: {
      colorCombinations: {
        whiteBg2,
        whiteBorder1,
        whitePrimary,
        text3White,
        whiteBg3,
      },
      colorTypes: {
        primary,
        white,
        neutral1,
        background4,
        text5,
        text3,
        background5,
      },
    },
    fontSizes,
    margins,
  } = themeVars;
  return {
    Heading: {
      common: {
        background: 'transparent',
        color: white,
        fontSize: fontSizes.xxxl,
        letterSpacing: 'normal',
        padding: [margins.xs, margins.md, 0],
      },
    },
    mybets: JSSThemeMyBets61900(themeVars),
    Button: {
      root: {
        borderRadius: '2px',
        lineHeight: '26px',
        padding: '5px 20px',
        fontWeight: 'bold',
        fontSize: 12,
        ...whiteBg2,
        ...applyOnlyDesktop({
          '&:hover': whiteBorder1,
        }),
      },
      block: {
        width: '100%',
      },
      linkDefault: {
        color: white,
        '@media not all and (pointer: coarse)': {
          //applyOnlyDesktop
          '&:hover': {
            color: white,
            opacity: 0.7,
            background: 'transparent',
          },
        },
        '@media (pointer: coarse)': {
          color: white,
          opacity: 0.7,
          background: 'transparent',
        },
      },
      primary: {
        ...whitePrimary,
        boxShadow: '0 5px 15px #29b93a',
        ...applyOnlyDesktop({
          '&:hover': {
            ...whiteBg3,
          },
        }),
      },
      linkSecondary: {
        '&:hover': {
          background: 'transparent',
        },
      },
      secondary: {
        background: 'transparent',
        color: white,
        '&:hover': {
          background: 'transparent',
          color: primary,
        },
      },
      accent: {
        background: '#29b93a',
        backgroundColor: '#29b93a',
        transition: '.3s ease-in',
        boxShadow: '0 5px 15px #29b93a',
        '&:hover': {
          background: '#29b93a',
          boxShadow: '0 5px 15px #82C191',
        },
      },
      large: {
        lineHeight: '42px',
        fontSize: fontSizes.xl,
      },
      small: {
        padding: [margins.xs, margins.md],
      },
      linkAccent: {
        color: primary,
        ...applyOnlyDesktop({
          '&:hover': {
            color: primary,
            background: 'transparent',
          },
        }),
      },
      default: {
        ...text3White,
        '&:hover': {
          color: text3,
          background: text5,
        },
      },
    },
    betslip: betslip(themeVars),
    NoBetsMessage: {
      root: {
        background: background5,
        color: white,
        fontWeight: 'normal',
        fontSize: fontSizes.sm,
      },
    },
    Geoblock: {
      logoGeoblock: {
        background: text3,
      },
      rootGeoblock: {
        background: background5,
      },
    },
    sportsMenu: JSSThemeSportsMenu61900(themeVars),
    form: JSSThemeForm61900(themeVars),
    headerMobile: JSSThemeHeaderMobile61900(themeVars),
    banners: JSSThemeBannerItems61900(themeVars),
    headerMenu: JSSThemeHeaderMenu61900(themeVars),
    outcomes: JSSThemeOutcomes61900(themeVars),
    header: JSSThemeHeader61900(themeVars),
    authForm: JSSThemeAuthForm61900(themeVars),
    balance: JSSThemeBalance61900(themeVars),
    bonuses: JSSThemeBonuses61900(themeVars),
    coupons: JSSThemeCoupons61900(themeVars),
    popularLeagues: JSSThemePopularLeagues61900(themeVars),
    casino: JSSThemeCasino61900(themeVars),
    search: JSSThemeSearch61900(themeVars),
    footerAll: JSSThemeFooterAll61900(themeVars),
    tooltip: JSSThemeTooltip61900(themeVars),
    live: JSSThemeLive61900(themeVars),
    accountSection: JSSThemeAccountSection61900(themeVars),
    oryx: JSSThemeOryx61900(themeVars),
    dropdownMenu: JSSThemeDropdownMenu61900(themeVars),
    affiliates: JSSThemeAffiliates61900(themeVars),
    promotions: JSSThemePromotions61900(themeVars),
    registration: JSSThemeRegistration61900(themeVars),
    LiveCalendar: {
      common: {
        margin: 0,
      },
      h2: {
        background: '#0c0f19',
      },
      dateTitle: {
        color: text3,
      },
      link: {
        color: text3,
        transition: '.3s ease-in-out',
        '&:hover': {
          color: primary,
        },
      },
      dateEventNoMarkets: {
        '&:hover': {
          background: '#eee',
          color: text3,
        },
      },
      dateEvent: {
        color: text3,
        '&:hover': {
          background: '#eee',
        },
      },
    },
    BetslipMyBetsPanelTitle: {
      heading: {
        boxShadow: `none`,
        background: 'transparent',
        color: white,
      },
    },
    BetslipMyBetsStakePotentialTotalUI: {
      stakePotentialWrapper: {
        color: white,
        borderTop: `1px solid ${neutral1}`,
      },
    },
    BetslipMyBetsPanelUI: {
      panel: {
        background: background4,
        borderRadius: '2px',
      },
    },
    resets: JSSTheme61900Resets(themeVars),
    OfflineMessage: {
      popup: {
        color: text3,
      },
    },
  };
};

export const getJSSThemePatterns61900: GetJSSThemePatternsType = (
  themeVars
) => {
  const {
    colors: {
      colorCombinations: {
        whiteNeutral3,
        whitePrimary,
        whiteAccent,
        text2Neutral2,
        whiteBg4,
        whiteBg1,
      },
    },
    fontSizes,
    margins,
  } = themeVars;
  return {
    buttons: {
      primary: {
        ...whitePrimary,
        ...applyOnlyDesktop({
          '&:hover': whiteNeutral3,
        }),
      },
      secondary: {
        ...text2Neutral2,
        ...applyOnlyDesktop({
          '&:hover': whiteBg4,
        }),
      },
      accent: {
        ...whiteAccent,
        ...applyOnlyDesktop({
          '&:hover': whiteBg1,
        }),
      },
      large: {
        lineHeight: '42px',
        fontSize: fontSizes.xl,
      },
      small: {
        padding: [margins.xs, margins.md],
      },
    },
  };
};
